import { render, staticRenderFns } from "./DashboardComplaints.vue?vue&type=template&id=4bad00f6"
import script from "./DashboardComplaints.vue?vue&type=script&lang=ts"
export * from "./DashboardComplaints.vue?vue&type=script&lang=ts"
import style0 from "./DashboardComplaints.vue?vue&type=style&index=0&id=4bad00f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports